import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './config/ThemeContext';
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import PricingPage from './pages/PricingPage';
import MmhcPage from './pages/MmhcPage';
import PhnPage from './pages/PhnPage';
import CliniciansPage from './pages/CliniciansPage';
import IarWorkflowPage from './pages/IarWorkflowPage';
import ClinicalNotesPage from './pages/ClinicalNotesPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import ConfirmPage from './pages/ConfirmPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/solutions/mmhc" element={<MmhcPage />} />
          <Route path="/solutions/phn" element={<PhnPage />} />
          <Route path="/solutions/clinicians" element={<CliniciansPage />} />
          <Route path="/workflows/iar" element={<IarWorkflowPage />} />
          <Route path="/workflows/clinical-notes" element={<ClinicalNotesPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/confirm" element={<ConfirmPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;

